import { render, staticRenderFns } from "./AssetsDownload.vue?vue&type=template&id=b14235bc&scoped=true&"
import script from "./AssetsDownload.vue?vue&type=script&lang=js&"
export * from "./AssetsDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14235bc",
  null
  
)

export default component.exports